import { ACTIONS } from '../config/constants';

export function fetchTags() {
  return (dispatch, getState) => {
    dispatch({ type: ACTIONS.TYPES.TAG.GET_INITIALIZED });

    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_fetchTags`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        },
        params: { product: getState().app.product }
      }
    ).then(res => {
      const tags = res.data.data[0].attributes.tags
        .map(tag => ({
          id: tag.id,
          title: tag.title
            .split(' ')
            .map(
              word =>
                `${
                  word !== 'and'
                    ? word.slice(0, 1).toUpperCase() + word.slice(1)
                    : word
                }`
            )
            .join(' ')
            .replace('Pa', 'PA')
            .replace('Em ', 'EM ')
            .replace('Thoracic-r', 'Thoracic-R')
            .replace('/renal', '/Renal')
            .replace('/nutritional', '/Nutritional')
            .replace('/ears/nose/throat', '/Ears/Nose/Throat'),
          shortname: tag.shortname,
          totalCount: tag.totalCount,
          correctCount: tag.correctCount,
          accountCorrectCount: tag.accountCorrectCount,
          accountTotalCount: tag.accountTotalCount,
          imageUrl: tag.imageUrl,
          questionCount: tag.questionCount,
          abemPercent: tag.abemPercent,
          testPercent2: tag.testPercent2,
          uniqueCompleted: tag.uniqueCompleted
        }))
        .sort((a, b) => (a.title < b.title ? -1 : 1));

      //HOTFIX
      getState().app.backupTags = tags; //TODO IF EVER BACK HERE FIX W/PROPER ACTION

      dispatch({
        type: ACTIONS.TYPES.TAG.GET_SUCCESS,
        tags
      });
    });
  };
}

export function fetchExamTags() {
  return (dispatch, getState) => {
    dispatch({ type: ACTIONS.TYPES.EXAMTAG.GET_INITIALIZED });

    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_fetchExamTags`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        },
        params: { product: getState().app.product }
      }
    ).then(res => {
      const tags = res.data.data[0].attributes.tags
        .map(tag => ({
          id: tag.id,
          title: tag.title.toUpperCase(),
          shortname: tag.shortname,
          totalCount: tag.totalCount,
          correctCount: tag.correctCount,
          accountCorrectCount: tag.accountCorrectCount,
          accountTotalCount: tag.accountTotalCount,
          imageUrl: tag.imageUrl,
          questionCount: tag.questionCount,
          abemPercent: tag.abemPercent,
          uniqueCompleted: tag.uniqueCompleted
        }))
        .sort((a, b) => (a.title < b.title ? -1 : 1));

      //HOTFIX
      getState().app.backupTags = tags; //TODO IF EVER BACK HERE FIX W/PROPER ACTION

      dispatch({
        type: ACTIONS.TYPES.EXAMTAG.GET_SUCCESS,
        tags
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/tags.js